import { FlightTakeoff, FlightLand } from '@mui/icons-material';

export const DepartureCompanies = ({ vuelos, iconColor }) => (
  <p className='flex items-center gap-2'>
    <span>- </span>
    <FlightTakeoff sx={{ color: iconColor }} />
    {[...new Set(vuelos.flat().map((vuelo) => vuelo.company))].join(' + ')}
  </p>
);

export const ArrivalCompanies = ({ vuelos, iconColor }) => (
  <p className='flex items-center gap-2'>
    <span>- </span>
    <FlightLand sx={{ color: iconColor }} />
    {[...new Set(vuelos.flat().map((vuelo) => vuelo.company))].join(' + ')}
  </p>
);
